import React from "react";
import PropTypes from "prop-types";
import { Navbar, NavbarBrand } from "shards-react";
import { GoChevronLeft } from "react-icons/go";

import appStore, { actions as appActions } from "../../core/app.store";

class SidebarMainNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: appStore.getState().app.menuVisible !== false,
    };
    this.onChange = this.onChange.bind(this);
    this.handleToggleSidebar = this.handleToggleSidebar.bind(this);
  }

  componentDidMount() {
    this.unsubscribe = appStore.subscribe(this.onChange);
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  onChange() {
    this.setState({ menuVisible: appStore.getState().app.menuVisible !== false });
  }

  handleToggleSidebar(e) {
    e.preventDefault();
    appActions.toggleSidebar();
  }

  render() {
    const toggle_class = this.state.menuVisible ? "sidebar-open" : "sidebar-close";
    const { hideLogoText } = this.props;

    const SUB_DOMAIN = process.env.REACT_APP_SUB_DOMAIN || "";
    const dashboard = `${SUB_DOMAIN}/view-projects-superadmin`;

    return (
      <div className="main-navbar">
        <Navbar className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0" type="light">
          <NavbarBrand className="w-100 mr-0" href={dashboard} style={{ lineHeight: "25px" }}>
            <div className="d-table m-auto">
              <img
                id="main-logo"
                className="d-inline-block align-top mr-1"
                style={{ maxWidth: "140px" }}
                src={require("../../images/logo.png")}
                alt="IQVIA Unstructured Data"
              />
              <br />
              {!hideLogoText && <div className="d-none d-md-inline ml-1">Unstructured Data</div>}
            </div>
          </NavbarBrand>
          <button type="button" className={`toggle-sidebar ${toggle_class}`} onClick={this.handleToggleSidebar} aria-label="Toggle sidebar">
            <GoChevronLeft />
          </button>
        </Navbar>
      </div>
    );
  }
}

SidebarMainNavbar.propTypes = {
  hideLogoText: PropTypes.bool,
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false,
};

export default SidebarMainNavbar;
